import { MediaTypeVO } from '@repo/types'
import { PowerBiReportDataVO } from '@repo/types/src/types/PowerBiReportDataVO'

export const ARGS_DESCRIPTIONS: Record<string, string[]> = {
  NAME: [
    'cliente',
    'nome cliente',
    'nome do cliente',
    'pessoa',
    'nome pessoa',
    'nome da pessoa',
    'parametro cliente',
    'parametro nome cliente'
  ],
  OWNER: [
    'consultor',
    'nome consultor',
    'nome do consultor',
    'nome responsavel',
    'nome do responsavel',
    'nome vendedor',
    'nome atendente',
    'nome do vendedor',
    'parametro consultor',
    'parametro vendedor',
    'parametro responsavel',
    'responsavel',
    'seu nome',
    'vendedor'
  ],

  DEALER: [
    'loja',
    'nome loja',
    'nome da loja',
    'dealer',
    'nome dealer',
    'nome do dealer',
    'parametro loja',
    'parametro dealer',
    'concessionaria'
  ]
}

export const MEDIA_TYPES: Record<string, MediaTypeVO> = {
  MEDIA_AUDIO: {
    label: 'Áudio',
    icon: 'audio',
    acceptedFormats: '.aac,.amr,.mp3,.m4a,.ogg',
    ref: 'audio',
    maxFileSize: 16000000,
    maxFileSizeLabel: '16mb'
  },
  MEDIA_IMAGE: {
    label: 'Imagem',
    icon: 'image',
    acceptedFormats: '.jpeg,.jpg,.png',
    ref: 'image',
    maxFileSize: 5000000,
    maxFileSizeLabel: '5mb'
  },
  MEDIA_VIDEO: {
    label: 'Vídeo',
    icon: 'video',
    acceptedFormats: '.mp4',
    ref: 'video',
    maxFileSize: 16000000,
    maxFileSizeLabel: '16mb'
  },
  MEDIA_DOCUMENT: {
    label: 'Documento',
    icon: 'file',
    acceptedFormats: '.txt,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.pdf',
    ref: 'file',
    maxFileSize: 100000000,
    maxFileSizeLabel: '100mb'
  }
}

export const CHAT_DASHBOARD_DATA: PowerBiReportDataVO = {
  reportId: 'bd877bad-0a07-41fe-82e6-8293cd9e95c2',
  groupId: '401835ff-1cd2-40f1-b008-a99d6c2ecac1'
}

export const TIMEOUT_SNACKBAR = 2500

export const BOUNCE_TIMEOUT = 1000
